/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import * as React from "react";
import { NavBar } from "../../common/NavBar";
import { IgnoreZonesBreadCrumbs } from "./IgnoreZonesBreadCrumbs";
import { createIgnoreZonesLinksArray } from "./EditIgnoreZonesUtils/createIgnoreZonesLinksArray";
import { useNavigate } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";
import { useFlexIgnoreZonesOnboardingStore } from "../Sites/SiteAboutPage/FlexIgnoreZonesOnboarding/flexIgnoreZonesOnboardingStore";
import { EMPTY_FLEX_PRESETS_LIST } from "../Sites/SiteAboutPage/FlexIgnoreZonesOnboarding/flexIgnoreZonesLdEmpty";
import { FlexIgnoreZonesNewPresetDialog } from "../Sites/SiteAboutPage/FlexIgnoreZonesOnboarding/FlexIgnoreZonesNewPresetDialog";
import {
  FLEX_IZ_CREATE_NEW_PRESET_OPTION,
  FLEX_IZ_NO_IGNORE_ZONES_OPTION,
} from "../Sites/SiteAboutPage/FlexIgnoreZonesOnboarding/flexIzPresetSelectConstants";
import { handleSubmitFlexIgnoreZones } from "./EditIgnoreZonesUtils/handleSubmitFlexIgnoreZones";
import {
  findPresetIgnoreZoneRowForTemplate,
  getDirtyFlexPresetLocalIds,
  getEditIgnoreZonesFlexPresetMenuPresets,
} from "./EditIgnoreZonesUtils/flexEditIgnoreZonesUtils";
import { runAfterEditIgnoreZonesBaseLoad } from "./EditIgnoreZonesUtils/runAfterEditIgnoreZonesBaseLoad";
import { pointsCreator } from "./EditIgnoreZonesUtils/pointsCreatorLarger";
import ZwibblerComponent from "./ZwibblerComponet";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { ActuateButton } from "../../common/ActuateButton";
import { EditViewSyncButton } from "../../common/EditViewSyncButton";
import { SyncNeededBanner } from "../../common/SyncNeededBanner";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { handleSubmitIgnoreZones } from "./EditIgnoreZonesUtils/handleSubmitIgnoreZones";
import * as LinesIcon from "../../../../assets/LinesIcon.png";
import * as CornerBoxes from "../../../../assets/CornerBoxes.png";
import BackdropLoadingScreen from "../../common/BackdropLoadingScreen";
import { getEditIgnoreZonesInfo } from "./EditIgnoreZonesUtils/getEditIgnoreZonesInfo";
import { pointsCreatorIgnoreZones } from "./EditIgnoreZonesUtils/pointCreatorIgnoreZones";
import {
  Dispatcher,
  IgnoreZone,
} from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { Tooltip } from "@mui/material";
import { IgnoreZonePreviewHoverLayer } from "../../common/ignoreZoneHover/IgnoreZonePreviewHoverLayer";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getAllCameras } from "../EditCamera/EditCameraUtils/getAllCameras";
import {
  getNumbersAfterEditCamera,
  getNumbersAfterSites,
} from "../EditCamera/EditCamera";
import { resetEditIgnoreZonesState } from "./EditIgnoreZonesUtils/resetEditIgnoreZonesState";
import { PopOutEditor } from "./PopOutEditor";
import IgnoreZoneBuilder from "../../common/IgnoreZoneBuilder";
import {
  ImportZonesFromVmsButton,
  ImportedZonesOverlay,
} from "../../common/ImportSettings/ImportZonesFromVmsButton";
import {
  EMPTY_IMPORT_CAPABILITIES,
  ImportPolygon,
  SiteImportCapabilities,
  readImportCapabilities,
} from "../../utils/importSettingsApi";

const readHasFlexScheduleFromSiteInfo = (): boolean => {
  try {
    const raw = localStorage.getItem("siteInfo");
    if (!raw) {
      return false;
    }
    const parsed = JSON.parse(raw) as { has_flex_schedule?: boolean };
    return parsed?.has_flex_schedule === true;
  } catch {
    return false;
  }
};

export const EditIgnoreZones = ({
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  const [breadcrumbs, setBreadCrumbs] = React.useState([]);

  const [visibleIgnoreZones, setVisibleIgnoreZones] = React.useState([]);

  const [ignorezoneEditorVisible, setIgnorezoneEditorVisible] =
    React.useState(false);

  const [selectedIgnoreZone, setSelectedIgnoreZone] = React.useState("");

  const ignoreZonesLiveRef = React.useRef<any[]>([]);
  const selectedIgnoreZoneLiveRef = React.useRef("");
  ignoreZonesLiveRef.current = visibleIgnoreZones as any[];
  selectedIgnoreZoneLiveRef.current = selectedIgnoreZone;

  const [editsMade, setEditsMade] = React.useState(false);

  const [pageLoading, setPageLoading] = React.useState(true);

  const [largerMode, setLargerMode] = React.useState(false);

  // const [dimensions, setDimensions] = React.useState({
  //   width: 640,
  //   height: 360,
  // });

  const [adjustedDimensions, setAdjustedDimensions] = React.useState({
    x: 720,
    y: 576,
  });

  const [dimensions, setDimensions] = React.useState<{
    width: number;
    height: number;
  } | null>(null);

  const handleImageLoad = (
    event: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;

    // setDimensions(resizeImage(naturalWidth, naturalHeight));
  };

  const navigate = useNavigate();
  const { isFeatureEnabled } = useFeatureFlag();
  const showFlexIgnoreZones = isFeatureEnabled("showFlexIgnoreZones", false);

  const siteId = Number(getNumbersAfterSites(location.href));

  const cameraIdForPage = Number(getNumbersAfterEditCamera(location.href));

  const enabledBySite = useFlexIgnoreZonesOnboardingStore((s) => s.enabledBySite);
  const flexPresetsForCamera = useFlexIgnoreZonesOnboardingStore(
    (s) => s.presetsByCamera[cameraIdForPage] ?? EMPTY_FLEX_PRESETS_LIST
  );
  const updatePresetZones = useFlexIgnoreZonesOnboardingStore(
    (s) => s.updatePresetZones
  );
  const loadCameraContext = useFlexIgnoreZonesOnboardingStore(
    (s) => s.loadCameraContext
  );
  const createCustomPresetDraft = useFlexIgnoreZonesOnboardingStore(
    (s) => s.createCustomPresetDraft
  );
  const removeLocalPresetDraft = useFlexIgnoreZonesOnboardingStore(
    (s) => s.removeLocalPresetDraft
  );
  const updatePresetName = useFlexIgnoreZonesOnboardingStore(
    (s) => s.updatePresetName
  );
  const cameraContexts = useFlexIgnoreZonesOnboardingStore((s) => s.cameraContexts);

  const [hasFlexSchedule, setHasFlexSchedule] = React.useState(
    readHasFlexScheduleFromSiteInfo
  );

  // ENG-2461: what the site's VMS can import (from the About payload the
  // base load already fetches) and the polygons being previewed for import.
  const [importCapabilities, setImportCapabilities] =
    React.useState<SiteImportCapabilities>(EMPTY_IMPORT_CAPABILITIES);
  const [importPreviewPolygons, setImportPreviewPolygons] = React.useState<
    ImportPolygon[] | null
  >(null);
  const canImportZones =
    importCapabilities.importable_settings.includes("zones");

  const flexIgnoreZonesEnabledForSite =
    showFlexIgnoreZones && enabledBySite[siteId] === true;
  const flexIzActive = flexIgnoreZonesEnabledForSite && hasFlexSchedule;

  const flexIzActiveRef = React.useRef(false);
  React.useEffect(() => {
    flexIzActiveRef.current = flexIzActive;
  }, [flexIzActive]);

  const [loadProgressPercent, setLoadProgressPercent] = React.useState<
    number | undefined
  >(undefined);
  const [loadProgressMessage, setLoadProgressMessage] = React.useState("");
  const [flexZonesBaseline, setFlexZonesBaseline] = React.useState<
    Record<string, string>
  >({});
  const [selectedFlexPresetLocalId, setSelectedFlexPresetLocalId] =
    React.useState("");
  const selectedFlexPresetLocalIdRef = React.useRef("");
  React.useEffect(() => {
    selectedFlexPresetLocalIdRef.current = selectedFlexPresetLocalId;
  }, [selectedFlexPresetLocalId]);

  const [newPresetDialog, setNewPresetDialog] = React.useState<{
    cameraId: number;
    presetLocalId: string;
    cameraName: string;
  } | null>(null);

  const isMountedRef = React.useRef(true);
  const flexLoadAbortRef = React.useRef<AbortController | null>(null);

  const flexHasUnsavedChanges = React.useMemo(() => {
    if (!flexIzActive) {
      return false;
    }
    return (
      getDirtyFlexPresetLocalIds(
        getEditIgnoreZonesFlexPresetMenuPresets(flexPresetsForCamera),
        flexZonesBaseline
      ).length > 0
    );
  }, [flexIzActive, flexPresetsForCamera, flexZonesBaseline]);

  const selectedFlexPreset = React.useMemo(
    () =>
      flexPresetsForCamera.find((p) => p.localId === selectedFlexPresetLocalId) ??
      null,
    [flexPresetsForCamera, selectedFlexPresetLocalId]
  );

  const presetNameFieldWidth = React.useMemo(
    () => Math.min(Math.max(adjustedDimensions.x, 280), 720),
    [adjustedDimensions.x]
  );

  const setVisibleIgnoreZonesForPage = React.useCallback(
    (updater: React.SetStateAction<any[]>) => {
      setVisibleIgnoreZones((prev) => {
        const next =
          typeof updater === "function"
            ? (updater as (p: any[]) => any[])(prev)
            : updater;
        if (
          flexIzActiveRef.current &&
          selectedFlexPresetLocalIdRef.current &&
          selectedFlexPresetLocalIdRef.current !== FLEX_IZ_NO_IGNORE_ZONES_OPTION
        ) {
          updatePresetZones(
            cameraIdForPage,
            selectedFlexPresetLocalIdRef.current,
            next
          );
        }
        return next;
      });
    },
    [updatePresetZones, cameraIdForPage]
  );

  /**
   * Sidebar rows always mirror `GET /camera/{id}/ignore_zones/` (store: `defaultZones`)
   * so every preset shows the same product list; the active preset row is resolved on click.
   */
  const flexSidebarZones = React.useMemo((): IgnoreZone[] => {
    if (!flexIzActive) {
      return visibleIgnoreZones as IgnoreZone[];
    }
    const defaultZones =
      cameraContexts[cameraIdForPage]?.defaultZones ?? [];
    return defaultZones.length > 0
      ? defaultZones
      : (visibleIgnoreZones as IgnoreZone[]);
  }, [flexIzActive, cameraContexts, cameraIdForPage, visibleIgnoreZones]);

  const zonesForSidebarList = flexIzActive
    ? flexSidebarZones
    : (visibleIgnoreZones as IgnoreZone[]);

  const handleFlexSidebarZoneClick = React.useCallback(
    (templateRow: IgnoreZone) => {
      const fromPreset = findPresetIgnoreZoneRowForTemplate(
        templateRow,
        visibleIgnoreZones as IgnoreZone[]
      );
      let zoneForEditor: IgnoreZone;
      if (fromPreset) {
        zoneForEditor = fromPreset;
      } else {
        zoneForEditor = {
          ...templateRow,
          coordinates: Array.isArray(templateRow.coordinates)
            ? JSON.parse(JSON.stringify(templateRow.coordinates))
            : [],
        };
        if (!zoneForEditor.coordinates?.length) {
          zoneForEditor.coordinates = [];
        }
        setVisibleIgnoreZonesForPage([
          ...(visibleIgnoreZones as IgnoreZone[]),
          zoneForEditor,
        ]);
      }
      setSelectedIgnoreZone(zoneForEditor.label);
      setIgnorezoneEditorVisible(true);
      localStorage.setItem("ignoreZoneColor", zoneForEditor.line_color);
      localStorage.setItem(
        "ignoreZones",
        JSON.stringify(zoneForEditor.coordinates || [])
      );
      setLargerMode(false);
    },
    [visibleIgnoreZones, setVisibleIgnoreZonesForPage]
  );

  const beginEditIgnoreZonesReload = React.useCallback(() => {
    flexLoadAbortRef.current?.abort();
    flexLoadAbortRef.current = new AbortController();
    const ac = flexLoadAbortRef.current;
    getEditIgnoreZonesInfo(
      setPageLoading,
      setBreadCrumbs,
      setVisibleIgnoreZones,
      setDimensions,
      setAdjustedDimensions,
      showFlexIgnoreZones
        ? {
            deferPageLoadingFinish: true,
            setHasFlexSchedule,
            onSiteAbout: (about) =>
              setImportCapabilities(readImportCapabilities(about)),
            onBaseLoadComplete: (siteAbout) =>
              runAfterEditIgnoreZonesBaseLoad({
                signal: ac.signal,
                showFlexIgnoreZones,
                hasFlexSchedule: siteAbout.has_flex_schedule === true,
                setPageLoading,
                setVisibleIgnoreZones,
                setLoadProgress: setLoadProgressPercent,
                setLoadMessage: setLoadProgressMessage,
                setFlexZonesBaseline,
                setSelectedFlexPresetLocalId,
                isMounted: () => isMountedRef.current,
              }),
          }
        : {
            setHasFlexSchedule,
            onSiteAbout: (about) =>
              setImportCapabilities(readImportCapabilities(about)),
          }
    );
  }, [showFlexIgnoreZones]);

  const handleSitesBreadcrumbClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    localStorage.setItem("level0Click", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "false");
    navigate("/sites");
  };

  const handleSingularSiteBreadcrumbClick = () => {
    navigate(`/sites/aboutsite/${siteId}`);
  };

  const handleIgnoreZoneClick = (object: any) => {
    setIgnorezoneEditorVisible(true);
    localStorage.setItem("ignoreZoneColor", object.line_color);
    localStorage.setItem("ignoreZones", JSON.stringify(object.coordinates));
  };

  const transformCoordinates = (coords: number[][][]): number[][][] => {
    return coords.map((group) =>
      group.map(([x, y]) => [
        x * adjustedDimensions.x,
        y * adjustedDimensions.y,
      ])
    );
  };

  const [allCamerasData, setAllCamerasData] = React.useState<any[]>([]);

  const [cameraIndex, setCameraIndex] = React.useState(0);

  const [popOutEditorDialogOpen, setPopOutEditorDialogOpen] =
    React.useState(false);

  const [iZBuilder, setIZBuilder] = React.useState(<></>);

  const [siteSchedules, setSiteSchedules] = React.useState([]);

  React.useEffect(() => {
    isMountedRef.current = true;
    beginEditIgnoreZonesReload();
    getAllCameras(
      Number(getNumbersAfterSites(location.href)),
      Number(getNumbersAfterEditCamera(location.href)),
      setAllCamerasData,
      setCameraIndex
    );
    localStorage.setItem("siteId", getNumbersAfterSites(location.href));
    localStorage.setItem(
      "currentCameraId",
      getNumbersAfterEditCamera(location.href)
    );
    return () => {
      isMountedRef.current = false;
      flexLoadAbortRef.current?.abort();
    };
  }, [beginEditIgnoreZonesReload]);

  React.useEffect(() => {
    if (!flexIzActive) {
      setSelectedFlexPresetLocalId((prev) => (prev === "" ? prev : ""));
      setFlexZonesBaseline((prev) =>
        Object.keys(prev).length === 0 ? prev : {}
      );
      return;
    }
    const menu = getEditIgnoreZonesFlexPresetMenuPresets(
      flexPresetsForCamera,
      selectedFlexPresetLocalId
    );
    if (menu.length === 0) {
      return;
    }
    const valid =
      selectedFlexPresetLocalId &&
      menu.some((p) => p.localId === selectedFlexPresetLocalId);
    if (!valid) {
      setSelectedFlexPresetLocalId(menu[0].localId);
      setVisibleIgnoreZones(JSON.parse(JSON.stringify(menu[0].zones || [])));
    }
  }, [flexIzActive, flexPresetsForCamera, selectedFlexPresetLocalId]);

  React.useEffect(() => {
    if (ignorezoneEditorVisible) {
      setIZBuilder(
        <IgnoreZoneBuilder
          shapeColor={localStorage.ignoreZoneColor}
          height={adjustedDimensions.y}
          width={adjustedDimensions.x}
          imageURL={JSON.parse(localStorage.preview_url)}
          shapesArray={transformCoordinates(
            JSON.parse(localStorage.ignoreZones)
          )}
          setIgnorezoneEditorVisible={setIgnorezoneEditorVisible}
          setEditsMade={setEditsMade}
          visibleIgnoreZones={visibleIgnoreZones}
          selectedIgnoreZone={selectedIgnoreZone}
          setVisibleIgnoreZones={
            flexIzActive ? setVisibleIgnoreZonesForPage : setVisibleIgnoreZones
          }
          largerMode={largerMode}
          setLargerMode={setLargerMode}
          dimensions={dimensions}
          setIZBuilder={setIZBuilder}
          allIgnoreZonesShown={false}
          siteSchedules={siteSchedules}
          visibleIgnoreZonesLiveRef={ignoreZonesLiveRef}
          selectedIgnoreZoneLiveRef={selectedIgnoreZoneLiveRef}
        />
      );
    } else {
      setIZBuilder(<></>);
    }
  }, [ignorezoneEditorVisible, flexIzActive, setVisibleIgnoreZonesForPage]);

  const flexPresetMenuPresets = React.useMemo(
    () =>
      getEditIgnoreZonesFlexPresetMenuPresets(
        flexPresetsForCamera,
        selectedFlexPresetLocalId
      ),
    [flexPresetsForCamera, selectedFlexPresetLocalId]
  );

  const flexCameraCtx = cameraContexts[cameraIdForPage];

  const handleFlexPresetSelectChange = (nextValue: string) => {
    if (nextValue === FLEX_IZ_CREATE_NEW_PRESET_OPTION) {
      const ctxZones = cameraContexts[cameraIdForPage]?.defaultZones;
      const zones =
        ctxZones && ctxZones.length > 0 ? ctxZones : visibleIgnoreZones;
      const localId = createCustomPresetDraft(
        cameraIdForPage,
        zones as IgnoreZone[]
      );
      setNewPresetDialog({
        cameraId: cameraIdForPage,
        presetLocalId: localId,
        cameraName: String(localStorage.currentCamera || ""),
      });
      void loadCameraContext(cameraIdForPage);
      return;
    }
    if (selectedFlexPresetLocalId) {
      updatePresetZones(
        cameraIdForPage,
        selectedFlexPresetLocalId,
        visibleIgnoreZones
      );
    }
    setSelectedFlexPresetLocalId(nextValue);
    const nextPreset = (
      useFlexIgnoreZonesOnboardingStore.getState().presetsByCamera[cameraIdForPage] ||
      []
    ).find((p) => p.localId === nextValue);
    setVisibleIgnoreZones(JSON.parse(JSON.stringify(nextPreset?.zones || [])));
  };

  return (
    <div>
      <SyncNeededBanner navigate={navigate} />
      <BackdropLoadingScreen
        openState={pageLoading}
        progressPercent={loadProgressPercent}
        message={loadProgressMessage || undefined}
      />
      {showFlexIgnoreZones && (
        <FlexIgnoreZonesNewPresetDialog
          open={newPresetDialog != null}
          cameraId={newPresetDialog?.cameraId ?? 0}
          presetLocalId={newPresetDialog?.presetLocalId ?? null}
          cameraName={newPresetDialog?.cameraName ?? ""}
          assignToSchedule={false}
          onClose={(reason, meta) => {
            if (reason === "submitted" && newPresetDialog) {
              setSelectedFlexPresetLocalId(
                meta?.presetLocalId ?? newPresetDialog.presetLocalId
              );
              void loadCameraContext(cameraIdForPage);
            }
            if (reason === "cancelled" && newPresetDialog) {
              removeLocalPresetDraft(
                newPresetDialog.cameraId,
                newPresetDialog.presetLocalId
              );
            }
            setNewPresetDialog(null);
          }}
        />
      )}
      <PopOutEditor
        popOutEditorDialogOpen={popOutEditorDialogOpen}
        setPopOutEditorDialogOpen={setPopOutEditorDialogOpen}
      />
      <div className="bg-actuate-grey absolute w-full h-full overflow-scroll">
        {!pageLoading && allCamerasData[0] && (
          <div>
            <div
              className={
                !navBarCollapsed
                  ? "absolute top-[15px] left-[150px] right-[1px] h-[59px] bg-white"
                  : "absolute top-[15px] left-[75px] right-[1px] h-[59px] bg-white"
              }
            >
              <IgnoreZonesBreadCrumbs
                linksArray={createIgnoreZonesLinksArray(breadcrumbs)}
                handleSitesBreadcrumbClick={handleSitesBreadcrumbClick}
                handleSingularSiteBreadcrumbClick={
                  handleSingularSiteBreadcrumbClick
                }
                styling="absolute top-[15px] left-[30px]"
              />
              {/* Sync control: the only sync cue on this page once the banner
                  is hidden with "Don't show again" (SUP-924). */}
              <div className="absolute top-[10px] right-[100px]">
                {!ignorezoneEditorVisible && (
                  <EditViewSyncButton navigate={navigate} />
                )}
              </div>
            </div>
            <div
              className={
                !navBarCollapsed
                  ? "absolute top-[87px] left-[150px] right-[1px] h-[58px] bg-white"
                  : "absolute top-[87px] left-[75px] right-[1px] h-[58px] bg-white"
              }
            >
              <p className="font-black font-mulish text-[20px] p-3 indent-4">
                {localStorage.currentCamera}
              </p>
            </div>
            <div className="absolute top-[97px] right-[100px] flex items-center gap-2">
              {!ignorezoneEditorVisible &&
                !pageLoading &&
                canImportZones &&
                !flexIzActive && (
                  <ImportZonesFromVmsButton
                    siteId={siteId}
                    cameraId={cameraIdForPage}
                    integrationLabel={
                      importCapabilities.integration_label || "the VMS"
                    }
                    offeredSettings={importCapabilities.importable_settings}
                    hasExistingZones={(visibleIgnoreZones as IgnoreZone[]).some(
                      (zone) =>
                        Array.isArray(zone.coordinates) &&
                        zone.coordinates.length > 0
                    )}
                    navigate={navigate}
                    onPreview={setImportPreviewPolygons}
                    onApplied={() => {
                      // Reload the zones the normal way; the import wrote
                      // them server-side, so the editor has no local edits.
                      setEditsMade(false);
                      setPageLoading(true);
                      beginEditIgnoreZonesReload();
                    }}
                  />
                )}
              {!ignorezoneEditorVisible && (
                <OrangeTextButton
                  onClick={() => {
                    if (flexIzActive) {
                      const dirty = getDirtyFlexPresetLocalIds(
                        getEditIgnoreZonesFlexPresetMenuPresets(flexPresetsForCamera),
                        flexZonesBaseline
                      );
                      void handleSubmitFlexIgnoreZones({
                        cameraId: cameraIdForPage,
                        customerId: siteId,
                        dirtyPresetLocalIds: dirty,
                        flexZonesBaseline,
                        navigate,
                        setPageLoading,
                      });
                      return;
                    }
                    handleSubmitIgnoreZones(
                      visibleIgnoreZones,
                      navigate,
                      setPageLoading
                    );
                  }}
                  text="Submit Changes"
                  disabled={
                    flexIzActive ? !flexHasUnsavedChanges : !editsMade
                  }
                />
              )}
            </div>
            <div
              className={
                !navBarCollapsed
                  ? "absolute top-[145px] left-[150px] right-[1px] h-full bg-white"
                  : "absolute top-[145px] left-[75px] right-[1px] h-full bg-white"
              }
            >
              {!ignorezoneEditorVisible && allCamerasData.length > 1 && (
                <div className="pt-[200px] w-[40px]">
                  <Tooltip
                    title={`Previous Camera: ${
                      cameraIndex === 0
                        ? allCamerasData[allCamerasData.length - 1].camera_name
                        : allCamerasData[cameraIndex - 1].camera_name
                    }`}
                    placement="top"
                    sx={{ fontSize: "12px", fontFamily: "mulish" }}
                  >
                    <div>
                      <OrangeTextButton
                        onClick={() => {
                          localStorage.setItem(
                            "currentCamera",
                            cameraIndex === 0
                              ? allCamerasData[allCamerasData.length - 1]
                                  .camera_name
                              : allCamerasData[cameraIndex - 1].camera_name
                          );
                          resetEditIgnoreZonesState(
                            setBreadCrumbs,
                            setVisibleIgnoreZones,
                            setIgnorezoneEditorVisible,
                            setSelectedIgnoreZone,
                            setEditsMade,
                            setPageLoading,
                            setDimensions,
                            setAllCamerasData,
                            setCameraIndex
                          );
                          setFlexZonesBaseline({});
                          setSelectedFlexPresetLocalId("");
                          if (cameraIndex === 0) {
                            navigate(
                              `/sites/${siteId}/editcamera/${
                                allCamerasData[allCamerasData.length - 1].id
                              }/editignorezones`
                            );
                            beginEditIgnoreZonesReload();
                            getAllCameras(
                              Number(getNumbersAfterSites(location.href)),
                              Number(getNumbersAfterEditCamera(location.href)),
                              setAllCamerasData,
                              setCameraIndex
                            );
                          } else {
                            navigate(
                              `/sites/${siteId}/editcamera/${
                                allCamerasData[cameraIndex - 1].id
                              }/editignorezones`
                            );
                            beginEditIgnoreZonesReload();
                            getAllCameras(
                              Number(getNumbersAfterSites(location.href)),
                              Number(getNumbersAfterEditCamera(location.href)),
                              setAllCamerasData,
                              setCameraIndex
                            );
                          }
                        }}
                        text={
                          <ArrowBackIosIcon fontSize="large" id="backButton" />
                        }
                        disabled={allCamerasData.length < 2}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
              {!ignorezoneEditorVisible && allCamerasData.length > 1 && (
                <div className="absolute top-[200px] left-[1250px]">
                  <Tooltip
                    title={`Next Camera: ${
                      cameraIndex + 1 === allCamerasData.length
                        ? allCamerasData[0].camera_name
                        : allCamerasData[cameraIndex + 1].camera_name
                    }`}
                    placement="top"
                    sx={{ fontSize: "12px", fontFamily: "mulish" }}
                  >
                    <div>
                      <OrangeTextButton
                        onClick={() => {
                          localStorage.setItem(
                            "currentCamera",
                            cameraIndex + 1 === allCamerasData.length
                              ? allCamerasData[0].camera_name
                              : allCamerasData[cameraIndex + 1].camera_name
                          );
                          resetEditIgnoreZonesState(
                            setBreadCrumbs,
                            setVisibleIgnoreZones,
                            setIgnorezoneEditorVisible,
                            setSelectedIgnoreZone,
                            setEditsMade,
                            setPageLoading,
                            setDimensions,
                            setAllCamerasData,
                            setCameraIndex
                          );
                          setFlexZonesBaseline({});
                          setSelectedFlexPresetLocalId("");
                          if (cameraIndex + 1 === allCamerasData.length) {
                            navigate(
                              `/sites/${siteId}/editcamera/${allCamerasData[0].id}/editignorezones`
                            );
                            beginEditIgnoreZonesReload();
                            getAllCameras(
                              Number(getNumbersAfterSites(location.href)),
                              Number(getNumbersAfterEditCamera(location.href)),
                              setAllCamerasData,
                              setCameraIndex
                            );
                          } else {
                            navigate(
                              `/sites/${siteId}/editcamera/${
                                allCamerasData[cameraIndex + 1].id
                              }/editignorezones`
                            );
                            beginEditIgnoreZonesReload();
                            getAllCameras(
                              Number(getNumbersAfterSites(location.href)),
                              Number(getNumbersAfterEditCamera(location.href)),
                              setAllCamerasData,
                              setCameraIndex
                            );
                          }
                        }}
                        text={
                          <ArrowForwardIosIcon
                            fontSize="large"
                            id="backButton"
                          />
                        }
                        disabled={allCamerasData.length < 2}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
              {!ignorezoneEditorVisible && (
                <div>
                  <div
                    className={
                      !navBarCollapsed
                        ? "overflow-auto absolute left-[855px] top-[75px] min-h-[360px] w-[305px]"
                        : "overflow-auto absolute left-[855px] top-[75px] min-h-[360px] w-[305px]"
                    }
                  >
                    <div className="absolute left-[0px] top-[0px] w-[275px]">
                      {zonesForSidebarList.map((object: IgnoreZone) => {
                        return (
                          <div
                            key={object.label}
                            role="button"
                            onClick={() => {
                              if (flexIzActive) {
                                handleFlexSidebarZoneClick(object);
                                return;
                              }
                              setSelectedIgnoreZone(object.label);
                              handleIgnoreZoneClick(object);
                              setLargerMode(false);
                            }}
                          >
                            <div
                              key={object.label}
                              style={{
                                height: 25,
                                width: 6,
                                background: `${object.line_color}`,
                              }}
                              className="absolute"
                            ></div>
                            <p className="font-mulish text-[16px] indent-5">
                              {object.label_display_name}
                            </p>
                            &nbsp;
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
              {!pageLoading && !ignorezoneEditorVisible && (
                <div className="absolute top-[13px] left-[70px] z-[1] flex flex-col gap-2 items-start">
                  {flexIzActive &&
                    selectedFlexPresetLocalId &&
                    selectedFlexPresetLocalId !== FLEX_IZ_NO_IGNORE_ZONES_OPTION &&
                    selectedFlexPreset && (
                    <TextField
                      variant="standard"
                        label="Preset name"
                        size="small"
                        value={selectedFlexPreset.name ?? ""}
                        onChange={(e) =>
                          updatePresetName(
                            cameraIdForPage,
                            selectedFlexPresetLocalId,
                            e.target.value,
                            true
                          )
                        }
                      sx={{
                          paddingBottom: "20px",
                          width: presetNameFieldWidth,
                          "& .MuiInputBase-input": { fontFamily: "Mulish" },
                          "& .MuiInputLabel-root": { fontFamily: "Mulish" },
                        }}
                      />
                    )}
                  <IgnoreZonePreviewHoverLayer
                    className="relative"
                    zones={visibleIgnoreZones as IgnoreZone[]}
                    enabled={
                      !ignorezoneEditorVisible &&
                      !pageLoading &&
                      visibleIgnoreZones.length > 0
                    }
                  >
                    <img
                      src={JSON.parse(localStorage.preview_url)}
                      style={{
                        width: `${adjustedDimensions.x}px`,
                        height: `${adjustedDimensions.y}px`,
                      }}
                      onLoad={handleImageLoad}
                      alt="TestCameraPhoto"
                    />
                    {!ignorezoneEditorVisible &&
                      visibleIgnoreZones.map((object: any) => {
                        return (
                          <div
                            className="absolute top-[0px]"
                            key={object.label}
                          >
                            {object.coordinates[0] &&
                              object.coordinates.map((array: any, index: any) => {
                                return (
                                  <svg
                                    className="absolute top-[0px]"
                                    key={index}
                                    style={{
                                      width: `${adjustedDimensions.x}px`,
                                      height: `${adjustedDimensions.y}px`,
                                    }}
                                  >
                                    {dimensions && (
                                      <polygon
                                        points={pointsCreator(
                                          object.coordinates[index],
                                          adjustedDimensions.y,
                                          adjustedDimensions.x
                                        )}
                                        stroke={object.line_color}
                                        strokeWidth="5"
                                        fill={object.line_color}
                                        fillOpacity="50%"
                                      />
                                    )}
                                  </svg>
                                );
                              })}
                          </div>
                        );
                      })}
                    {!ignorezoneEditorVisible && importPreviewPolygons && (
                      <ImportedZonesOverlay
                        polygons={importPreviewPolygons}
                        width={adjustedDimensions.x}
                        height={adjustedDimensions.y}
                      />
                    )}
                  </IgnoreZonePreviewHoverLayer>
                </div>
              )}

              <div
                className={
                  ignorezoneEditorVisible
                    ? "player pointer-events-auto absolute top-[0px] left-[67px] z-[2] w-[775px] h-[200px]"
                    : "player pointer-events-none absolute top-[0px] left-[67px] z-0 w-[775px] h-[200px]"
                }
                role="button"
                tabIndex={ignorezoneEditorVisible ? 0 : -1}
              >
                {
                  // <ZwibblerComponent />
                  // <IgnoreZoneBuilder
                  //   shapeColor={localStorage.ignoreZoneColor}
                  //   height={adjustedDimensions.y}
                  //   width={adjustedDimensions.x}
                  //   imageURL={JSON.parse(localStorage.preview_url)}
                  //   shapesArray={transformCoordinates(
                  //     JSON.parse(localStorage.ignoreZones)
                  //   )}
                  //   setIgnorezoneEditorVisible={setIgnorezoneEditorVisible}
                  //   setEditsMade={setEditsMade}
                  //   visibleIgnoreZones={visibleIgnoreZones}
                  //   selectedIgnoreZone={selectedIgnoreZone}
                  //   setVisibleIgnoreZones={setVisibleIgnoreZones}
                  //   largerMode={largerMode}
                  //   setLargerMode={setLargerMode}
                  //   dimensions={dimensions}
                  // />
                  iZBuilder
                }
              </div>

              {/* <div className="absolute top-[7px] left-[150px] right-[1px] h-[170px] w-[640px] bg-white"></div> */}
            </div>
            {!ignorezoneEditorVisible && (
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[130px] left-[980px] w-[420px] font-mulish text-[18px] text-actuate-blue"
                    : "absolute top-[130px] left-[905px] w-[420px] font-mulish text-[18px] text-actuate-blue"
                }
              >
                {flexIzActive &&
                  (flexCameraCtx?.loading ? (
                    <p className="font-mulish text-[12px] text-gray-600 py-[4px]">
                      Loading presets…
                    </p>
                  ) : (
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ maxWidth: 360, mt: "4px", mb: "12px" }}
                    >
                      <InputLabel
                        id="flex-iz-preset-label-edit-iz"
                        sx={{ fontFamily: "Mulish" }}
                      >
                        Preset
                      </InputLabel>
                      <Select
                        labelId="flex-iz-preset-label-edit-iz"
                        label="Preset"
                        value={selectedFlexPresetLocalId || ""}
                        onChange={(e) =>
                          handleFlexPresetSelectChange(String(e.target.value))
                        }
                        sx={{ fontFamily: "Mulish" }}
                      >
                        {flexPresetMenuPresets.length === 0 && (
                          <MenuItem disabled value="" sx={{ fontFamily: "Mulish" }}>
                            No presets available
                          </MenuItem>
                        )}
                        {flexPresetMenuPresets.map((preset) => (
                          <MenuItem
                            key={preset.localId}
                            value={preset.localId}
                            sx={{ fontFamily: "Mulish" }}
                          >
                            {preset.name}
                          </MenuItem>
                        ))}
                        <MenuItem
                          value={FLEX_IZ_CREATE_NEW_PRESET_OPTION}
                          sx={{
                            color: "#FF8400",
                            fontFamily: "Mulish",
                            fontWeight: 700,
                          }}
                        >
                          + CREATE NEW PRESET
                        </MenuItem>
                      </Select>
                    </FormControl>
                  ))}
                <div className="mt-[4px]">
                  &nbsp; Click the Ignore Zone below you&apos;d like to edit.
                </div>
              </div>
            )}
            {ignorezoneEditorVisible && !largerMode && (
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[172px] left-[1020px] font-mulish text-[20px] text-actuate-blue min-w-[470px] pr-[40px]"
                    : "absolute top-[172px] left-[945px] font-mulish text-[20px] text-actuate-blue min-w-[500px] pr-[40px]"
                }
              >
                <p className="font-bold text-[17px]">INSTRUCTIONS:</p>
                <br></br>
                <p className="font-normal text-[17px] ">
                  To begin creating a shape click anywhere on the image to start
                  adding points.
                </p>
                <br></br>
                <p className="font-normal text-[17px]">
                  To finish creating a shape, click on the first point created.
                </p>
                <br></br>
                <p className="font-normal text-[17px]">
                  To modify the shape click and drag the points to the desired
                  location.
                </p>
                <br></br>
                <p className="font-normal text-[17px]">
                  To add additional points to the shape, click on the line
                  between two points.
                </p>
                <br></br>
                <p className="font-normal text-[17px]">
                  To create an additional shape, click anywhere on the image to
                  start adding points.
                </p>
                <br></br>
                <p className="font-normal text-[17px]">
                  To delete a shape hover anywhere over the shape and click to
                  select. Then press the delete key on your keyboard.
                </p>
                <br></br>
                <p className="font-normal text-[17px]">
                  To delete a single point double click on the point. This
                  action will only work if the remaining shape will have at
                  least 3 points.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
